import React from "react";
import { Box } from "@mui/material";
import UserOrganizationView from "../../../components/user/UserOrganizationView";
import { useParams } from "react-router-dom";
import OrganizationPageLayout from "../../../components/Organizations/OrganizationLayout";

const OrganizationDetails = () => {
  const params = useParams();
  return (
    <Box sx={{ 
      mt: '130px', 
      minHeight: 'calc(100vh - 130px)', 
      pb: 5,
      px: 2,
      overflow: 'auto', // Ensure scrolling works
      height: 'auto' // Remove fixed height constraint
    }}>
      <OrganizationPageLayout title="Manage Organization">
        <UserOrganizationView organizationId={params.organizationId} />
      </OrganizationPageLayout>
    </Box>
  );
};

export default OrganizationDetails;
